import React from 'react'
import './index.scss'
import { RightsHolderModel, Rightsholders } from '@Entities/rightsholder'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import PaginationComponent from '@Components/Tables/Pagination'
import { Maybe } from '@Types'
import { PaginationInfo } from '@Entities/pagination'
import RightsholderAccountCard from '@Components/Cards/AccountCard/RightsholderAccountCard'

interface IProps {
    name: string
    rightsHolders: Maybe<Rightsholders>
    preloader: boolean
    limitItems: number
    openPopup: (status: boolean, id: number) => void
    paginationPages: Maybe<PaginationInfo>
    onChangePagination(): void
    viewDetails: boolean
}

const TopRightsHoldersSection = (props: IProps) => {
    const { name, rightsHolders, preloader, limitItems, openPopup, paginationPages, onChangePagination, viewDetails } =
        props

    return (
        <div className="top-rightsholders-section">
            <div className="line-name">
                <p className="bold blue-text">
                    {name} ({rightsHolders ? rightsHolders.count : 0})
                </p>
            </div>
            <div className="rightsholders-block">
                <div className="grid-container">
                    {preloader ? (
                        <PointPreloader />
                    ) : (
                        rightsHolders?.rightsholders.map((item: RightsHolderModel, index: number) => (
                            <RightsholderAccountCard
                                key={item.id ? item.id : index}
                                rightsholderData={item}
                                openPopup={() => openPopup(true, item.id)}
                                viewDetails={viewDetails}
                            />
                        ))
                    )}
                    {rightsHolders && !rightsHolders.count && <p className="small no-results">No Members</p>}
                </div>
                {rightsHolders && rightsHolders.count > limitItems && (
                    <PaginationComponent
                        limit={limitItems}
                        paginationPages={paginationPages}
                        onChange={onChangePagination}
                    />
                )}
            </div>
        </div>
    )
}

export default TopRightsHoldersSection
